<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex justify-content-between flex-row w-100">
    <div class="d-flex flex-column justify-content-between w-50 pb-2">
      <div class="w-100">
        <label class="title_label mt-0">{{'BUSINESS.NAME' | translate | uppercase}}
          <i *ngIf="errorModel!=null && errorModel['Name']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color"
             pTooltip="{{errorModel['Name']|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="text" class="input_text_field" [(ngModel)]="specialOfferModel.name">
      </div>
      <div class="w-100 mt-auto">
        <label class="title_label mt-0">
          {{ 'BUSINESS.CHOOSE_COUNTRY' | translate | uppercase}}
          <i *ngIf="errorModel!=null && errorModel['countryIds']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color"
             pTooltip="{{errorModel['countryIds']|translate}}" tooltipPosition="top"></i>
        </label>
        <p-multiSelect id="no_borders" class="src_dropdown" filterPlaceHolder="{{'SEARCH' | translate}}..."
                       [options]="countries" [(ngModel)]="specialOfferModel.countriesId"
                       defaultLabel="{{'BUSINESS.SELECT_COUNTRY'|translate}}"
                       [showHeader]="false" optionLabel="countryName" optionValue="id" [maxSelectedLabels]="5"
                       selectedItemsLabel="{0} {{'INFO.ITEMS_SELECTED' | translate }}"></p-multiSelect>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between w-50 pb-2">
      <div class="w-100" style="height: 125px;">
        <label class="title_label mt-0">{{'BUSINESS.DESCRIPTION' | translate | uppercase}}
          <i *ngIf="errorModel!=null && errorModel['Description']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color"
             pTooltip="{{errorModel['Description']|translate}}" tooltipPosition="top"></i>
        </label>
        <textarea rows="7" cols="50" class="input_text_field input_text_field_dialog special_offer_desc"
                  [(ngModel)]="specialOfferModel.description"></textarea>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between flex-row w-100">
    <span class="offer_details_text">{{'BUSINESS.OFFER_DETAILS' | translate}}</span>
  </div>
  <div class="d-flex justify-content-between w-100">
    <div class="w-50 mt-auto">
      <label class="title_label mt-0">
        {{ 'BUSINESS.CHOOSE_APP' | translate | uppercase}}
        <span class="fw-light">({{ 'BUSINESS.ONE_OR_MORE' | translate}})</span>
        <i *ngIf="errorModel!=null && errorModel['apps']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['apps']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-multiSelect class="src_dropdown no_border_select" filterPlaceHolder="{{'SEARCH' | translate}}..."
                     [options]="projectList" [(ngModel)]="projectsSelected"
                     defaultLabel="{{'BUSINESS.CHOOSE_APP' | translate | titlecase}}" [displaySelectedLabel]="true"
                     [showHeader]="true" optionLabel="name" optionValue="value" [maxSelectedLabels]="5"
                     selectedItemsLabel="{0} {{'INFO.ITEMS_SELECTED' | translate }}"></p-multiSelect>
    </div>
    <div class="w-50 mt-auto">
      <label class="title_label mt-0">
        {{ 'BUSINESS.CHOOSE_APP_FREE' | translate | uppercase}}
        <span class="fw-light">({{ 'BUSINESS.ONE_OR_MORE' | translate}})</span>
        <i *ngIf="errorModel!=null && errorModel['appsFree']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['appsFree']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-multiSelect class="src_dropdown no_border_select" filterPlaceHolder="{{'SEARCH' | translate}}..."
                     [options]="projectList" [(ngModel)]="freeProjectsSelected"
                     defaultLabel="{{'BUSINESS.CHOOSE_APP' | translate | titlecase}}" [displaySelectedLabel]="true"
                     [showHeader]="true" optionLabel="name" optionValue="value" [maxSelectedLabels]="5"
                     selectedItemsLabel="{0} {{'INFO.ITEMS_SELECTED' | translate }}"></p-multiSelect>
    </div>
  </div>
  <div class="d-flex justify-content-between w-100">
    <div class="w-50 mt-auto d-flex flex-row">
      <div class="w-50 me-3">
        <label class="title_label mt-0">{{'BUSINESS.ENTER_YEARLY_PRICE' | translate | uppercase}}
          <i *ngIf="errorModel!=null && errorModel['YPrice']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color"
             pTooltip="{{errorModel['YPrice']|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="number" min="0" class="input_text_field" [(ngModel)]="specialOfferModel.yearlyPrice">
      </div>
      <div class="w-50">
        <label class="title_label mt-0">{{'BUSINESS.ENTER_MONTHLY_PRICE' | translate | uppercase}}
          <i *ngIf="errorModel!=null && errorModel['MPrice']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color"
             pTooltip="{{errorModel['MPrice']|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="number" min="0" class="input_text_field" [(ngModel)]="specialOfferModel.mounthlyPrice">
      </div>
    </div>
    <div class="w-50 mt-auto">
      <label class="title_label mt-0">{{'BUSINESS.UP_TO' | translate | uppercase}}
        <i *ngIf="errorModel!=null && errorModel['UpToFree']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['UpToFree']|translate}}" tooltipPosition="top"></i>
      </label>
      <div class="d-flex flex-row align-items-end">
        <input type="number" min="0" class="input_text_field w-50" [(ngModel)]="specialOfferModel.maxNumberOfVenuesForSecondaryProjects">
        <label class="label_no_bottom_border ms-3">{{'BUSINESS.VENUES' | translate | uppercase}}</label>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between w-100">
    <div class="w-50 mt-auto pe-2">
      <label class="title_label mt-0">{{'BUSINESS.UP_TO' | translate | uppercase}}
        <i *ngIf="errorModel!=null && errorModel['UpTo']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['UpTo']|translate}}" tooltipPosition="top"></i>
      </label>
      <div class="d-flex flex-row align-items-end">
        <input type="number" min="0" class="input_text_field w-50" [(ngModel)]="specialOfferModel.maxNumberOfVenuesForPrimaryProjects">
        <label class="label_no_bottom_border ms-3">{{'BUSINESS.VENUES' | translate | uppercase}}</label>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between w-100 pb-4">
    <div class="w-50 mt-auto pe-2">
      <label class="title_label mt-0">{{'BUSINESS.CHOOSE_DURATION_DATE' | translate | uppercase}}
        <i *ngIf="errorModel!=null && errorModel['Date']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['Date']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-calendar [(ngModel)]="specialOfferModel.validUtilDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between w-100 pb-2">
    <div class="w-50 d-flex flex-row justify-content-start">
      <button *ngIf="enableEdit" class="btn_without_color w-50"
              (click)="removeSpecialOffer(specialOfferModel)">{{'BUSINESS.REMOVE_SPECIAL_OFFER' | translate}}</button>
    </div>
    <div class="w-50 d-flex flex-row">
      <button class="btn_without_color btn_border_color w-50 me-2" (click)="cancel()">{{'CANCEL' | translate }}</button>
      <button *ngIf="!enableEdit" class="btn_in_color w-50" (click)="addOrEditSpecialOffer(specialOfferModel)">{{'CREATE' |
        translate}}</button>
      <button *ngIf="enableEdit" class="btn_in_color w-50" (click)="addOrEditSpecialOffer(specialOfferModel)">{{'EDIT' |
        translate}}</button>
    </div>
  </div>
</div>
